import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { AudioLinesIcon, DnaIcon, FileIcon, ImageIcon, LinkIcon, PlusIcon, SplitIcon, VideoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export type ContentTypeUI =
  | "image"
  | "video"
  | "audio"
  | "link"
  | "fromTemplate"
  | "split"
  | "doc"
  | "fromStockGallery";

interface Props {
  defaultOpen?: boolean;
  onSelect: (type: ContentTypeUI) => void;
}

export const CreateContentMenu = ({
  onSelect,
  onOpenChange,
  defaultOpen,
}: Props & { onOpenChange?: (open: boolean) => void }) => {
  const { t } = useTranslation();
  return (
    <DropdownMenu defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger>
        <Button size="sm">
          <PlusIcon className="w-4 h-4" /> {t("content.create")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => onSelect("image")}>
          <ImageIcon className="w-4 h-4" /> {t("content.image")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("video")}>
          <VideoIcon className="w-4 h-4" /> {t("content.video")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("audio")}>
          <AudioLinesIcon className="w-4 h-4" /> {t("content.audio")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("link")}>
          <LinkIcon className="w-4 h-4" /> {t("content.link")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("doc")}>
          <FileIcon className="w-4 h-4" /> {t("content.doc")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => onSelect("fromTemplate")}>
          <DnaIcon className="w-4 h-4" /> {t("content.fromTemplate")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("fromStockGallery")}>
          <ImageIcon className="w-4 h-4" /> {t("content.fromStockGallery")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect("split")}>
          <SplitIcon className="w-4 h-4" /> {t("entities.splitContent")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
